import { render, staticRenderFns } from "./PsEventModal.vue?vue&type=template&id=223d92b1&scoped=true&"
import script from "./PsEventModal.vue?vue&type=script&lang=js&"
export * from "./PsEventModal.vue?vue&type=script&lang=js&"
import style0 from "./PsEventModal.vue?vue&type=style&index=0&id=223d92b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223d92b1",
  null
  
)

export default component.exports